import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Touch the Firebase init early so a missing-env warning fires in dev
// before the first render (no-op in prod if env is set).
import './lib/firebase';

import { AuthProvider } from './lib/auth/AuthProvider';
import { ToastProvider } from './components/ToastProvider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { StoreHealthToaster } from './components/StoreHealthToaster';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <ToastProvider>
        <StoreHealthToaster />
        <ErrorBoundary section="app">
          <App />
        </ErrorBoundary>
      </ToastProvider>
    </AuthProvider>
  </StrictMode>,
);
